export const MAX_COURSE_ATTACHMENTS = 5;
export const MAX_COURSE_ATTACHMENT_FILE_NAME_LENGTH = 200;

/** Stable key for the predefined mandatory attachment label (i18n lookup). */
export const APPROVED_SCHEME_ATTACHMENT_LABEL_KEY = "approvedSchemeOfStudies";

/**
 * Optional attachment label choices for additional (non-scheme) rows.
 * Sent as the attachment `label` string in create/update payloads.
 */
export const OPTIONAL_COURSE_ATTACHMENT_LABELS = [
	"Curriculum",
	"Competency Standards",
	"Assessment Packs",
	"Teaching Learning Material",
	"Notifications",
	"Qualification Pack",
	"Others",
] as const;

export type OptionalCourseAttachmentLabel = (typeof OPTIONAL_COURSE_ATTACHMENT_LABELS)[number];
